import { useEffect } from 'react';

import { useActions } from '../../../../../hooks/useActions';
import { setOverwriteAmountMembership } from '../../../../../store/redux-slices/membership/common';

type UseAddMemberPaymentSummaryForm = {
  overwriteAmount?: boolean;
  overwrittenAmount?: number;
};

export const useAddMemberPaymentSummaryForm = ({
  overwriteAmount,
  overwrittenAmount,
}: UseAddMemberPaymentSummaryForm) => {
  const SetOverwriteAmountMembership = useActions(setOverwriteAmountMembership);

  useEffect(() => {
    SetOverwriteAmountMembership({
      // eslint-disable-next-line no-undefined
      overwrittenAmount: overwriteAmount ? overwrittenAmount : undefined,
      overwriteAmount: overwriteAmount || false,
    });
  }, [SetOverwriteAmountMembership, overwriteAmount, overwrittenAmount]);
};
